import type { ReviewTransport } from './transport'
import type { GoogleReviewsResponse } from './types'

export interface GoogleReviewClientOptions {
  transport: ReviewTransport
}

export interface GoogleReviewClient {
  fetchGoogleReviews(placeId: string): Promise<GoogleReviewsResponse>
}

export function createGoogleReviewClient({ transport }: GoogleReviewClientOptions): GoogleReviewClient {
  return {
    fetchGoogleReviews(placeId) {
      return transport.request<GoogleReviewsResponse>({
        method: 'GET',
        url: `/reviews/google/${placeId}`
      })
    }
  }
}
